"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDateAndClearTime = exports.parseDate = exports.DATE_RE = void 0;
/* eslint-disable no-useless-escape */

const baseMonthDayYear = '\\d{1,2}[\\/-]\\d{1,2}[\\/-](\\d{2}|\\d{4})';
const baseYearMonthDay = '\\d{4}[\\/-]\\d{1,2}[\\/-]\\d{1,2}';
const nextCharNotNumeric = '(?=($|\\D))';
const DATE_RE = {
  isMonthDayYear: new RegExp(`^${baseMonthDayYear}$`, 'i'),
  isYearMonthDay: new RegExp(`^${baseYearMonthDay}$`, 'i'),
  containsMonthDayYear: new RegExp(`^${baseMonthDayYear}${nextCharNotNumeric}`, 'i'),
  containsYearMonthDay: new RegExp(`^${baseYearMonthDay}${nextCharNotNumeric}`, 'i')
};
exports.DATE_RE = DATE_RE;
const parseDateAndClearTime = str => {
  let result;
  if (typeof str !== 'string') {
    return str;
  }
  if (DATE_RE.containsMonthDayYear.test(str)) {
    [result] = str.match(DATE_RE.containsMonthDayYear);
    if (DATE_RE.isMonthDayYear.test(result)) {
      return `${result} 00:00:00`;
    }
  }
  if (DATE_RE.containsYearMonthDay.test(str)) {
    [result] = str.match(DATE_RE.containsYearMonthDay);
    if (DATE_RE.isYearMonthDay.test(result)) {
      return `${result} 00:00:00`;
    }
  }
  return str;
};
exports.parseDateAndClearTime = parseDateAndClearTime;
const parseDate = str => {
  let result;
  if (typeof str !== 'string') {
    return str;
  }
  if (DATE_RE.containsMonthDayYear.test(str)) {
    [result] = str.match(DATE_RE.containsMonthDayYear);
    if (DATE_RE.isMonthDayYear.test(result)) {
      return result;
    }
  }
  if (DATE_RE.containsYearMonthDay.test(str)) {
    [result] = str.match(DATE_RE.containsYearMonthDay);
    if (DATE_RE.isYearMonthDay.test(result)) {
      return result;
    }
  }
  return str;
};
exports.parseDate = parseDate;